export const NAME = "name";
export const EMAIL = "email";
export const MOBILE = "mobile_number";
export const ROLE = "role";
export const GEOGRAPHICAL_REGION = "geographical_region_id";
export const STATE = "state";
export const CITY = "city";
export const STATUS = "status";

export const roles = [
  { label: "CRM Head", value: "CRM_HEAD" },
  { label: "SalesOps", value: "SALES_OPS" },
  { label: "Region Head", value: "REGION_HEAD" },
  { label: "Relationship Manager", value: "RELATIONSHIP_MANAGER" },
  { label: "Finance Team", value: "FINANCE_TEAM" },
  { label: "Inventory Team", value: "INVENTORY_TEAM" },
  { label: "Labs Team Head", value: "LABS_TEAM_HEAD" },
  { label: "Labs Team", value: "LABS_TEAM" },
  { label: "Product Team", value: "PRODUCT_TEAM" },
  { label: "B2C Fulfillment", value: "B2C_FULFILLMENT" },
];

export const statusOptions = [
  { label: "Active", value: "true" },
  { label: "Inactive", value: "false" },
];
